// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg-icon {
  width: 50px;
  height: 50px;
  fill: red;
}
svg-icon:hover {
  fill: orange;
}

.simplebar-wrapper {
  margin-left: 350px;
}

.simplebar-content > li > a {
  color: #fff !important;
}

.simplebar-content > li a svg.stroke-icon {
  stroke: #fff !important;
}

@media (max-width: 500px) {
  .simplebar-wrapper {
    margin-left: 0px;
    color: #fff !important;
  }
}
@media (max-width: 820px) {
  .simplebar-wrapper {
    margin-left: 0px;
    color: #fff !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/sidebar/sidebar.component.scss","webpack://./../contandoui2.0%20-%20TP/src/app/shared/components/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAkBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;ACjBF;ADmBE;EACE,YAAA;ACjBJ;;AD8BG;EACG,kBAAA;AC3BN;;ADiCA;EACC,sBAAA;AC9BD;;ADiCA;EACC,uBAAA;AC9BD;;ADgCA;EACC;IACI,gBAAA;IACA,sBAAA;EC7BH;AACF;AD+BG;EACE;IACE,gBAAA;IACA,sBAAA;EC7BL;AACF","sourcesContent":["// svg-icon {\n//    width: 50px;\n//    height: 50px;\n//    fill: red;\n \n//    &:hover {\n//      fill: orange;\n//    }\n//  }\n\n//  .simplebar-content > li > a{\n//   color: #fff!important;\n//  }\n\n//  .simplebar-content > li a svg.stroke-icon{\n//   stroke: #fff!important;\n//  }\n\nsvg-icon {\n  width: 50px;\n  height: 50px;\n  fill: red;\n\n  &:hover {\n    fill: orange;\n  }\n}\n  \n//  .sidebar-main-nav{\n//     border: 1px solid black;\n//     display: flex;\n//     justify-content: center;\n//     background-color: #642aa2;\n//     color: #fff;\n   \n//    }  \n   \n   .simplebar-wrapper{\n      margin-left:350px;\n \n   }\n\n       \n\n.simplebar-content > li > a{\n color: #fff!important;\n}\n\n.simplebar-content > li a svg.stroke-icon{\n stroke: #fff!important;\n}\n@media (max-width: 500px) {\n .simplebar-wrapper {\n     margin-left: 0px;\n     color: #fff!important;\n   }\n }\n   @media (max-width: 820px) {\n     .simplebar-wrapper {\n       margin-left: 0px;\n       color: #fff!important;\n     }\n   }\n\n","svg-icon {\n  width: 50px;\n  height: 50px;\n  fill: red;\n}\nsvg-icon:hover {\n  fill: orange;\n}\n\n.simplebar-wrapper {\n  margin-left: 350px;\n}\n\n.simplebar-content > li > a {\n  color: #fff !important;\n}\n\n.simplebar-content > li a svg.stroke-icon {\n  stroke: #fff !important;\n}\n\n@media (max-width: 500px) {\n  .simplebar-wrapper {\n    margin-left: 0px;\n    color: #fff !important;\n  }\n}\n@media (max-width: 820px) {\n  .simplebar-wrapper {\n    margin-left: 0px;\n    color: #fff !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
